import { Button, Stack, Typography } from '@mui/material';
import React from 'react'
import { makeTxtOverFLow } from '../utils/format';

function PathBtns({ btnsArr, overflow }) {
    return (
        <Stack direction="row" alignItems="center" >
            {btnsArr.map((i, index) => (
                <Stack direction="row" alignItems="center" key={index}>
                    <Button onClick={i.handleClick}
                        sx={{
                            fontSize: 12, fontWeight: 300,
                            textTransform: "none",
                            color: "black",
                            backgroundColor: "transparent",
                            "&:hover": {
                                color: "blue",
                            },
                        }}
                    >
                        {makeTxtOverFLow(i.label, overflow ?? 20)}
                    </Button>
                    {index < btnsArr.length - 1 && <Typography sx={{ fontSize: 12, fontWeight: 300 }}>&gt;</Typography>}
                </Stack>
            ))}
        </Stack>
    );
}

export default PathBtns